import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { catchError, map, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class ApiService {
  apiUrl = null;
  tokenKey = null;

  constructor(private http: HttpClient) { }

  getAccessToken() {
    return localStorage.getItem('access_token');
  }

  private getHeaders() {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json');
    return headers;
  }

  getApi(url: string): Observable<any> {
    return this.http.get(url, { headers: this.getHeaders() }).pipe(
      map(res => res),
      catchError(err => { this.catchError(err); return of(err.message) })
    );
  }

  postApi(url: string, postValue: any): Observable<any> {
    return this.http.post(url, postValue, { headers: this.getHeaders() }).pipe(
      map(res => res),
      catchError(err => { this.catchError(err); return of(err.message) })
    );
  }

  catchError(err) {
    throw err;
  }

  changePasswordByActivationCode(data) {
    return this.postApi(this.apiUrl + `Account/ChangePasswordByActivationCode`, data);
  }

  forgotPasswordGen(data) {
    return this.postApi(this.apiUrl + `Account/ForgetPassword`, data);
  }
  
  forgotUserNameGen(data) {
    return this.postApi(this.apiUrl + `Account/ForgetUserName`, data);
  }
}
